import { useContext } from 'react';
import { PdfViewerDialogContext } from './PdfViewerDialogContext';

export function usePdfViewerWithUrl(): (title: string, url: string) => void {
	const { openWithUrl } = useContext(PdfViewerDialogContext);
	return openWithUrl;
}
